/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Live_Caption_ChannelInputs */



/**
* | output |
* | --- |
* | "Caption channel" |
*
* @param {Live_Caption_ChannelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const live_caption_channel = /** @type {((inputs?: Live_Caption_ChannelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Live_Caption_ChannelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Chaîne de sous-titres")
	if (locale === "de") return /** @type {LocalizedString} */ ("Untertitelkanal")
	if (locale === "it") return /** @type {LocalizedString} */ ("Canale dei sottotitoli")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Канал субтитров")
	if (locale === "es") return /** @type {LocalizedString} */ ("Canal de subtítulos")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("字幕频道")
	if (locale === "ja") return /** @type {LocalizedString} */ ("字幕チャンネル")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कैप्शन चैनल")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Canal de legendas")
	return /** @type {LocalizedString} */ ("Caption channel")
});